<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Subscriptions</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="field-form-panel">
                <h4>{{subscriptionID > 0 || contactId > 0 ? memSubscription?.contactName : 'Add'}}</h4>
                <hr />
                <form [formGroup]="memSubscriptionForm">
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Subscription</label>
                            <input type="text" class="form-control" formControlName="subscription" />
                        </div>
                        <div class="form-group">
                            <label>Subscription Id</label>
                            <input type="text" class="form-control" formControlName="vSubscriptionId" />
                        </div>
                        <div class="form-group">
                            <label>Total Amount</label>
                            <input type="text" class="form-control" formControlName="totalAmount" />
                        </div>
                        <div class="form-group">
                            <label>Next Bill Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="dtNextBill" class="form-control" formControlName="dtNextBill" id="dtNextBill">
                                <mat-datepicker-toggle matSuffix [for]="dtNextBill"></mat-datepicker-toggle>
                                <mat-datepicker #dtNextBill></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Base Amount</label>
                            <input type="text" class="form-control" formControlName="baseAmount" />
                        </div>
                        <!--<div class="form-group">
                        <label>Paused</label>-->
                        <!--<p><input type="checkbox" formControlName="paused" /></p>-->
                        <!--<div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="paused" formControlName="paused" maxlength="50">
                                <label class="custom-control-label" for="paused"></label>
                            </div>
                        </div>-->
                        <div class="form-group">
                            <label>Tax Amount</label>
                            <input type="text" class="form-control" formControlName="taxAmount" />
                        </div>
                        <div class="form-group">
                            <label>Surcharge Amount</label>
                            <input type="text" class="form-control" formControlName="surchargeAmount" />
                        </div>
                        <!--<div class="form-group">
                            <label>Status</label>
                            <select class="form-control" formControlName="status">
                                <option value="0">-Select One-</option>
                                <option *ngFor="let type of ref_SubscriptionStatus_List" [value]="type.statusID">{{type.status}}</option>
                            </select>
                        </div>-->
                        <div class="form-group">
                            <label>Payment Method Id</label>
                            <input class="form-control" formControlName="vPaymentMethodID" />
                        </div>
                        <!--<div class="form-group">
                            <label>Coupon</label>
                            <input type="text" class="form-control" formControlName="coupon" />
                        </div>
                        <div class="form-group">
                            <label>Billing Method</label>
                            <select class="form-control" formControlName="paymentType">
                                <option value="0">-Select One-</option>
                                <option *ngFor="let billMethod of ref_MemBillingMethod_List" [value]="billMethod.methodID">{{billMethod.method}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Billing Day</label>
                            <input type="text" class="form-control" formControlName="billingDay" />
                        </div>

                        <div class="form-group">
                            <label>Error Message</label>
                            <input type="text" class="form-control" formControlName="errorMessage" />
                        </div>
                        <div class="form-group" *ngIf="subscriptionID  == 0 && contactId == 0">
                            <label>Contact</label>
                            <select class="form-control" formControlName="contactId" (change)="onChangeMemContact()">
                                <option value="0">-Select One-</option>
                                <option *ngFor="let item of memContact_dd" [value]="item.id">{{item?.text}}</option>
                            </select>
                        </div>-->
                    </div>
                    <div>
                        <div class="form-group">
                            <div class="button-group">
                                <button type="button" class="primary-btn" *ngIf="subscriptionID == 0 && contactId == 0" (click)="memSubscription_Create()">Save</button>
                                <button type="button" class="primary-btn" *ngIf="subscriptionID > 0 || contactId > 0" (click)="memSubscription_Update()">Update</button>
                                <button type="button" class="black-btn" *ngIf="subscriptionID > 0 || contactId > 0" (click)="subscription_Delete()">Delete</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="table-panel">
                <div class="">
                    <div class="text-right">
                        <div class="button-group" style="border:none;">
                        </div>
                    </div>
                </div>
                <div class="table-body">

                </div>
            </div>
        </div>
    </div>
</div>

